import {
  type FirebaseStorage,
  StringFormat,
  type UploadTask,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadBytesResumable,
  uploadString,
} from 'firebase/storage';

import { getApp } from './config';

let storageInstance: FirebaseStorage | null = null;

/**
 * Get the Storage instance (singleton). Importing this module pulls in
 * `firebase/storage` (+ `firebase/app`) — keep it out of bundles (e.g. the
 * public bio) that don't upload files.
 */
export function getStorageInstance(): FirebaseStorage {
  if (storageInstance) {
    return storageInstance;
  }
  storageInstance = getStorage(getApp());
  return storageInstance;
}

// Re-export Storage instance
export const storage = getStorageInstance;

// Re-export Storage types and constants
export type { FirebaseStorage, UploadTask };

// Re-export Storage functions so consumers don't have to depend on
// `firebase` directly (it's only installed in @ps/functions).
export {
  StringFormat,
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
  uploadString,
};
